import { useState, type JSX } from "react";
import { V3BodyGrey35 } from "../ReusableStyledComponents/V3BodyGrey35";
import { VerticalSpacing } from "../VerticalSpacing";
import { SelectItemsModal } from "../SelectItemsModal";
import { V3FakeIcon, V3FakeSelectBrandingBarWrapper, V3FakeSelectContent, V3FakeSelectIcon, V3FakeSelectWrapper } from "./FakeSelect.styles";
import { V3IconChevronDown, V3IconHelpCircle } from "../Icons";
import { FORMATED_SOURCE_TYPES } from "../../utils/getFormattedSourceTypes";
import { V3SettingsLabelWithTooltip } from "../../pagelayouts/settings/account/V3SettingsAccountPageLayout.styles";

export interface FakeSelectStyleProps {
    onClick?: () => void;
    hasContentSelected: boolean;
    text: string;
    label: string;
    tooltipContent?: string | JSX.Element;
    useHover?: boolean;
    icon?: JSX.Element;
    disabled?: boolean;
    brandingBar?: boolean;
    tooltipMaxWidth?: number;
}

export const FakeSelectStyle = ({
    onClick,
    hasContentSelected,
    text,
    label,
    tooltipContent,
    disabled = false,
    useHover = false,
    brandingBar = false,
    tooltipMaxWidth = 270,
    icon
}: FakeSelectStyleProps) => {
    const WrapperToUSe = brandingBar ? V3FakeSelectBrandingBarWrapper : V3FakeSelectWrapper;

    const hasIcon = !!icon;

    return (
        <>
            <VerticalSpacing bottom={6}>
                <V3SettingsLabelWithTooltip>
                    <div>
                        <V3BodyGrey35>
                            <strong>{label}</strong>
                        </V3BodyGrey35>
                    </div>
                    <div>
                        {!!tooltipContent && (
                            <V3Tooltip tooltipMaxWidth={tooltipMaxWidth} referenceContent={<V3IconHelpCircle />} tooltipContent={tooltipContent} />
                        )}
                    </div>
                </V3SettingsLabelWithTooltip>
            </VerticalSpacing>
            <WrapperToUSe
                onClick={() => {
                    onClick && onClick();
                }}
                $useHover={useHover && !disabled}
            >
                {!!icon && <V3FakeIcon $disabled={disabled}>{icon}</V3FakeIcon>}
                <V3FakeSelectContent
                    $hasContentSelected={hasContentSelected}
                    $customPaddingLeft={hasIcon ? (brandingBar ? "40px" : "30px") : undefined}
                    $disabled={disabled}
                >
                    {text}
                </V3FakeSelectContent>
                <V3FakeSelectIcon $disabled={disabled}>
                    <V3IconChevronDown />
                </V3FakeSelectIcon>
            </WrapperToUSe>
        </>
    );
};

import { V3Tooltip } from "../Tooltip";

interface FakeSelectProps {
    label: string;
    placeholder: string;
    items: { label: string; value: string }[];
    selectedItems: string[];
    onModalSubmitClose: (its: string[]) => void;
    useTypesList?: boolean;
    tooltipContent?: string | JSX.Element;
}

const typesList = FORMATED_SOURCE_TYPES.map((type) => ({ label: type.text || "", value: type.value }));

export const FakeSelectWithModal = ({
    label,
    items,
    selectedItems,
    onModalSubmitClose,
    placeholder,
    useTypesList,
    tooltipContent
}: FakeSelectProps) => {
    const [modalOpen, setModalOpen] = useState(false);

    const itemsToUse = useTypesList ? typesList : items;

    return (
        <>
            <VerticalSpacing bottom={12}>
                <FakeSelectStyle
                    label={label}
                    tooltipContent={tooltipContent}
                    onClick={() => {
                        if (!itemsToUse.length) return;
                        setModalOpen(true);
                    }}
                    hasContentSelected={!!selectedItems.length}
                    text={
                        (!!selectedItems.length &&
                            selectedItems.map((slctType) => itemsToUse.find((tp) => tp.value === slctType)?.label).join(", ")) ||
                        placeholder
                    }
                />
                {modalOpen && (
                    <SelectItemsModal
                        isOpen
                        setModalOpen={setModalOpen}
                        selectedItems={selectedItems}
                        items={itemsToUse}
                        onModalSubmitClose={onModalSubmitClose}
                    />
                )}
            </VerticalSpacing>
        </>
    );
};
